import { render } from "./Documentation.vue?vue&type=template&id=6107bd16"
import script from "./Documentation.vue?vue&type=script&lang=ts"
export * from "./Documentation.vue?vue&type=script&lang=ts"
script.render = render

export default script